module.exports = __webpack_public_path__ + "img/hubrid.491376c0.png";